import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c1a8637"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aside-main_sticky" }
const _hoisted_2 = { class: "aside-main_actions flex" }
const _hoisted_3 = { class: "bottom-actions" }
const _hoisted_4 = { class: "aside-main_actions_company-wrapper flex" }

import {computed, ref, watch} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useAsideMenu} from '../aside-menu.store';
    import CompanySelector from './CompanySelector.vue';
    import LanguageSelector from './LanguageSelector.vue';
    import NavigationTabsContainer from './NavigationTabsContainer.vue';
    import {useDisplayMobile} from '@/logged/common/composables';
    import {LogoWrapper, Skeleton} from '@/logged/common/ui';
    import {useAppContext} from '@/logged/config';
    import {useUser} from '@/logged/features/user';
    import {useDisplayMode} from '../stores';
    import WhiteLabel from '@/logged/common/ui/WhiteLabel.vue';
    import {VJoyButton, VJoyIcon} from '@maltjoy/core-vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AsideMenu',
  setup(__props) {

    const asideMenuStore = useAsideMenu();
    const appContext = useAppContext();
    const userStore = useUser();
    const displayModeStore = useDisplayMode();

    const {selectedIdentity} = storeToRefs(userStore);
    const {isMobileNavBarOpened} = storeToRefs(asideMenuStore);
    const {isDisplayModeFull, isDisplayModeReduced} = storeToRefs(displayModeStore);
    const isAdmin = computed<boolean>(() => !!userStore.user?.options.platformAdmin);
    const {loading} = storeToRefs(appContext);

    const isSelectorDisplayRight = computed<boolean>(() => !!userStore.user?.featureFlags['company-selector-display-right']);
    const {isDisplayMobile} = useDisplayMobile();

    const asideRef = ref<HTMLDivElement>();

    function handleCloseMobileNavBar() {
        asideMenuStore.setMobileNavBarOpened(false);
    }

    watch(isDisplayMobile, (value) => {
        if (value) {
            setTimeout(() => {
                if (asideRef.value) {
                    asideRef.value.style.transitionProperty = 'transform';
                }
            }, 300);
        } else {
            setTimeout(() => {
                if (asideRef.value) {
                    asideRef.value.style.transitionProperty = 'width, transform';
                }
            }, 300);
        }
    });

    function redirectToAdmin() {
        window.open('/admin');
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["aside-root", {isMobile: _unref(isDisplayMobile)}])
  }, [
    _createElementVNode("aside", {
      ref_key: "asideRef",
      ref: asideRef,
      class: _normalizeClass(["aside-main flex", {isFull: _unref(isDisplayModeFull), isReduced: _unref(isDisplayModeReduced), isMobile: _unref(isDisplayMobile), isSelectorDisplayRight: isSelectorDisplayRight.value}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_unref(selectedIdentity)?.whitelabellingEnabled)
          ? (_openBlock(), _createBlock(WhiteLabel, {
              key: 0,
              "company-name": _unref(selectedIdentity)?.organizationName,
              "company-logo": _unref(selectedIdentity)?.organizationLogoUrl,
              "is-reduced": _unref(isDisplayModeReduced)
            }, null, 8, ["company-name", "company-logo", "is-reduced"]))
          : (_openBlock(), _createBlock(_unref(LogoWrapper), { key: 1 }))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(NavigationTabsContainer),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_unref(loading) && !_unref(userStore).selectedIdentity)
              ? (_openBlock(), _createBlock(_unref(Skeleton), { key: 0 }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (isAdmin.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_unref(isDisplayModeReduced))
                          ? (_openBlock(), _createBlock(_unref(VJoyIcon), {
                              key: 0,
                              size: "xsmall",
                              name: "home",
                              color: "white",
                              title: _ctx.$msg('navbar.aside.tabs.title.admin'),
                              class: "aside-main_actions_company-wrapper_icon",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectToAdmin()))
                            }, null, 8, ["title"]))
                          : (_openBlock(), _createBlock(_unref(VJoyButton), {
                              key: 1,
                              variant: "admin",
                              size: "small",
                              class: "aside-main_actions_company-wrapper_cta",
                              "data-testid": "Admin",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (redirectToAdmin()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$msg('navbar.aside.tabs.title.admin')), 1)
                              ]),
                              _: 1
                            }))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(CompanySelector)
                ], 64))
          ]),
          _createVNode(LanguageSelector),
          (_unref(selectedIdentity)?.whitelabellingEnabled)
            ? (_openBlock(), _createBlock(_unref(LogoWrapper), {
                key: 0,
                "is-small": ""
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createVNode(_Transition, { name: "fade-opacity" }, {
      default: _withCtx(() => [
        (_unref(isDisplayMobile) && _unref(isMobileNavBarOpened))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "aside-overlay",
              onClick: handleCloseMobileNavBar
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})